export default __webpack_public_path__ + "static/media/ic_ahu_on.f2c6bb4f.svg";